import React, { Component } from 'react'

import { CSSTransitionGroup } from 'react-transition-group'

import Slide from './slide'
import Navigator from './navigator'

//Main Images
import DevelopMain from '../../assets/images/slides/desarrollo-scene.jpg'
import EcommerceMain from '../../assets/images/slides/ecommerce-scene.jpg'
import IcareMain from '../../assets/images/slides/icare-scene.jpg'
import LoyaltyMain from '../../assets/images/slides/loyalty-scene.jpg'
import SmartyMain from '../../assets/images/slides/smarty-scene.jpg'

//Overlay Images
import DevelopOverlay from '../../assets/images/slides/desarrollo-overlay.png'
import EcommerceOverlay from '../../assets/images/slides/ecommerce-overlay.png'
import IcareOverlay from '../../assets/images/slides/icare-overlay.png'
import LoyaltyOverlay from '../../assets/images/slides/loyalty-overlay.png'
import SmartyOverlay from '../../assets/images/slides/smarty-overlay.png'

//Mobile Images
import MobileDevelop from '../../assets/images/slides/small-desarrollo-mobile.jpg'
import MobileEcommerce from '../../assets/images/slides/small-ecommerce-mobile.jpg'
import MobileIcare from '../../assets/images/slides/small-icare-mobile.jpg'
import MobileLoyalty from '../../assets/images/slides/small-loyalty-mobile.jpg'
import MobileSmarty from '../../assets/images/slides/small-smarty-mobile.jpg'

import styled from 'styled-components'

const SliderContainer = styled.div`
  min-height: 100vh;
  transition: background linear 1s;
  position: relative;
  @media (max-width: 768px) {
    transition: background ease-in 0.2s;
  }
`

const LeftAction = styled.div`
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 3;
  width: 8vw;
  cursor: w-resize;
`

const RightAction = styled.div`
  height: 100vh;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 3;
  width: 8vw;
  cursor: e-resize;
`

class Slider extends Component {
  state = {
    slides: [
      {
        name: 'Desarrollo',
        backgroundColor: '#bed7e1',
        text: 'la experiencia de usuario.',
        btnText: 'ME INTERESA',
        main: DevelopMain,
        overlay: DevelopOverlay,
        mobile: MobileDevelop,
        mainStyle: {
          position: 'absolute',
          top: '0',
          width: '100%',
          bottom: '0',
          margin: 'auto'
        },
        overlayStyle: {
          position: 'absolute',
          top: '30%',
          left: '25%',
          width: '35vw'
        },
        link: '/develop',
        timer: 8.5
      },
      {
        name: 'Estrategia digital y analítica',
        backgroundColor: '#e1d2c0',
        text: 'estar en la era digital.',
        btnText: 'ME INTERESA',
        main: SmartyMain,
        overlay: SmartyOverlay,
        mobile: MobileSmarty,
        mainStyle: {
          position: 'absolute',
          top: '0',
          width: '100%',
          bottom: '0',
          margin: 'auto'
        },
        overlayStyle: {
          position: 'absolute',
          top: '45%',
          left: '13%',
          width: '45vw'
        },
        link: '/smarty',
        timer: 8
      },
      {
        name: 'Ecommerce',
        backgroundColor: '#bccbe0',
        text: 'vender por internet.',
        btnText: 'ME INTERESA',
        main: EcommerceMain,
        overlay: EcommerceOverlay,
        mobile: MobileEcommerce,
        mainStyle: {
          position: 'absolute',
          top: '0',
          width: '100%',
          bottom: '0',
          margin: 'auto'
        },
        overlayStyle: {
          position: 'absolute',
          top: '35%',
          left: '13%',
          width: '55vw'
        },
        link: '/ecommerce',
        timer: 7.5
      },
      {
        name: 'Automatización de Marketing',
        backgroundColor: '#e2dec0',
        text: 'automatizar tus envíos.',
        btnText: 'ME INTERESA',
        main: IcareMain,
        overlay: IcareOverlay,
        mobile: MobileIcare,
        mainStyle: {
          position: 'absolute',
          top: '0',
          width: '100%',
          bottom: '0',
          margin: 'auto'
        },
        overlayStyle: {
          position: 'absolute',
          top: '25%',
          left: '15%',
          width: '40vw'
        },
        link: '/icare',
        timer: 8
      },
      {
        name: 'Loyalty',
        backgroundColor: '#e3bdbe',
        text: 'clientes felices.',
        btnText: 'ME INTERESA',
        main: LoyaltyMain,
        overlay: LoyaltyOverlay,
        mobile: MobileLoyalty,
        mainStyle: {
          position: 'absolute',
          top: '0',
          width: '100%',
          bottom: '0',
          margin: 'auto'
        },
        overlayStyle: {
          position: 'absolute',
          top: '42%',
          left: '15%',
          width: '40vw'
        },
        link: '/loyalty',
        timer: 7
      }
    ],
    currentSlide: 0,
    orientation: 'right',
    forceBackSpace: false,
    action: 'forward',
    isMobile: false
  }

  _changeSlide = type => {
    let { currentSlide, slides, orientation } = this.state
    let max = slides.length - 1
    switch (type) {
      case 'backward':
        currentSlide--
        if (currentSlide < 0) {
          currentSlide = max
        }
        orientation = 'left'
        break
      default: {
        currentSlide++
        if (currentSlide > max) {
          currentSlide = 0
        }
        orientation = 'right'
        break
      }
    }
    this.setState({
      currentSlide: currentSlide,
      orientation: orientation,
      forceBackSpace: false,
      isMobile: false,
      action: type
    })
  }

  _turnOnBackSpace = (type, isMobile = false) => {
    let { forceBackSpace } = this.state
    if (isMobile === false) {
      if (forceBackSpace === false) {
        this.setState({
          forceBackSpace: true,
          action: type,
          isMobile: false
        })
      }
    } else {
      this.setState({
        isMobile: true,
        action: type,
        forceBackSpace: false
      })
    }
  }

  render() {
    let {
      slides,
      currentSlide,
      orientation,
      forceBackSpace,
      action,
      isMobile
    } = this.state

    let { menuIsOpen, contactIsOpen, welcomeIsOpen } = this.props

    let currentComponentSlide = slides[currentSlide]
    return (
      <SliderContainer
        className="d-flex align-content-center w-100 flex-wrap"
        style={{
          background: currentComponentSlide.backgroundColor,
          overflow: 'hidden'
        }}
      >
        <LeftAction
          className="d-none d-lg-block"
          onClick={() => this._turnOnBackSpace('backward')}
        />
        <RightAction
          className="d-none d-lg-block"
          onClick={() => this._turnOnBackSpace('forward')}
        />
        <LeftAction
          className="d-lg-none"
          onClick={() => this._turnOnBackSpace('backward', true)}
        />
        <RightAction
          className="d-lg-none"
          onClick={() => this._turnOnBackSpace('forward', true)}
        />
        <Slide
          {...currentComponentSlide}
          orientation={orientation}
          forceBackSpace={forceBackSpace}
          action={action}
          changeSlide={this._changeSlide}
          isMobile={isMobile}
          pause={menuIsOpen || contactIsOpen || welcomeIsOpen}
        />

        <Navigator turnOnBackSpace={this._turnOnBackSpace} slides={slides} />
      </SliderContainer>
    )
  }
}

export default Slider



// WEBPACK FOOTER //
// ./src/components/slider/slider.js